import { Users, Target, Heart } from 'lucide-react';
import { SEOHead } from '@/components/seo';
import { PAGE_SEO } from '@/lib/seo-config';

export default function About() {
  return (
    <div className="bg-[#050505] min-h-screen pt-24">
      <SEOHead
        title={PAGE_SEO.about.title}
        description={PAGE_SEO.about.description}
        keywords={PAGE_SEO.about.keywords}
        url="/about"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'About', url: '/about' },
        ]}
      />
      <section className="py-24 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 data-testid="about-title" className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 section-marker">About ClawStinger</h1>
          <p className="text-base md:text-lg text-zinc-400 leading-relaxed mb-16 max-w-2xl">
            We built ClawStinger because deploying OpenClaw should be as easy as using it. No SSH, no server management, no DevOps headaches.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
            {[
              { icon: Target, title: 'Our Mission', desc: 'Make AI assistants accessible to everyone by eliminating the technical barriers to self-hosted AI agents.' },
              { icon: Heart, title: 'Why We Built This', desc: 'We were frustrated by the complexity of setting up OpenClaw. 60 minutes of config for something that should take 60 seconds.' },
              { icon: Users, title: 'The Team', desc: 'A small team of developers and infrastructure engineers passionate about AI and developer experience.' },
            ].map((item, i) => {
              const Icon = item.icon;
              return (
                <div key={i} className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-8">
                  <Icon size={28} className="text-emerald-400 mb-4" />
                  <h3 className="text-white font-mono font-bold text-lg mb-2">{item.title}</h3>
                  <p className="text-zinc-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              );
            })}
          </div>

          <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-8">
            <h2 className="text-xl font-mono text-white font-bold mb-6">By the Numbers</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[['2,500+', 'Active Users'], ['15,000+', 'Instances Deployed'], ['8', 'Global Regions'], ['99.9%', 'Uptime SLA']].map(([num, label], i) => (
                <div key={i} className="text-center">
                  <p className="text-3xl font-mono font-bold text-emerald-400">{num}</p>
                  <p className="text-xs font-mono text-zinc-500 mt-1">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
